export const AuthenticationTranslations = {
    authenticationTranslations : {
        forgotPassword : 'Se te olvidó tu contraseña',
        description: 'Ingrese el correo electrónico con el que se registró y le enviaremos una nueva contraseña.',
        confirmation: {
            message: 'Hemos enviado una contraseña temporal a su dirección de correo electrónico. Por favor revise su bandeja de entrada para el correo electrónico titulado "Password Reset".',
        },
        accountConfirm: {
            heading: 'Confirmación de cuenta',
            description: 'Establezca una contraseña para su cuenta recién confirmada',
            success: 'Su cuenta ha sido confirmada y su contraseña ha sido establecida',
            failure: 'No se pudo confirmar su cuenta ni establecer la contraseña',
            already_confirmed: 'Su cuenta ya ha sido confirmada',
            submit: 'Establecer contraseña',
        },
        passwordReq: {
            minLength: 'La contraseña debe tener al menos 8 caracteres',
            confirmMatch: 'La confirmación de la contraseña debe coincidir'
        }
    }
}
